
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { getDateFormattedAsMoment } from '../../../core/utils/dates';
import { dateTypes } from '../../../shared/types/dates/date-models';
import HighCloudyImageBadge from './HighCloudyImageBadge.vue';

type AnyImage = Record<string, any>;

@Component({
  components: { HighCloudyImageBadge },
})
export default class SatellitalImagesStrip extends Vue {
  @Prop({ default: () => [] }) readonly images!: AnyImage[];
  @Prop({ default: 'src' }) readonly imageSrc!: string;
  @Prop({ default: 'id' }) readonly imageIdKey!: string;
  @Prop({ default: 0 }) readonly currentIndex!: number;
  @Prop({ default: '#3c4a66' }) readonly activeBorderColor!: string;

   mounted() {
    this.$nextTick(() => this.scrollItemIntoCenter(this.currentIndex, 'auto'));
  }

  imageKey(img: AnyImage, i: number) {
    return img[this.imageIdKey] || `${i}-${img[this.imageSrc] || 'no-src'}`;
  }

  getParsedDate(date: string) {
    return getDateFormattedAsMoment(
      date,
      dateTypes.dateYearFormatBars,
      dateTypes.dateYearFormatReverse
    );
  }

  onThumbClick(index: number, img: AnyImage) {
    if (this.currentIndex === index) {
      this.$emit('click-image', -1, null, false);
    } else {
      this.$emit('click-image', index, img, false);
    }
  }

  @Watch('currentIndex')
  onIndexChange(newIdx: number) {
    if (newIdx != null && newIdx >= 0) {
      this.$nextTick(() => this.scrollItemIntoCenter(newIdx, 'smooth'));
    }
  }

  private scrollItemIntoCenter(index: number, behavior: ScrollBehavior = 'smooth') {
    const container = this.$refs.strip as HTMLElement | undefined;
    const thumbs = this.$refs.thumb as HTMLElement[] | undefined;
    if (!container || !thumbs || !thumbs[index]) return;

    const el = thumbs[index];
    const elLeft = el.offsetLeft;                 
    const elWidth = el.offsetWidth;
    const containerWidth = container.clientWidth;

    let target = elLeft - (containerWidth - elWidth) / 2;

    const max = container.scrollWidth - containerWidth;
    if (target < 0) target = 0;
    if (target > max) target = max;

    container.scrollTo({ left: target, behavior });
  }
}
